import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Cellar } from "../../types/Cellar";

type ConfirmDialogProps = {
  cellar: Cellar;
  open: boolean;
  setOpen: (toggle: boolean) => void;
  handleDeleteCellar: any;
};

const ConfirmDeleteCellarDialog: React.FC<ConfirmDialogProps> = ({
  open,
  setOpen,
  cellar,
  handleDeleteCellar,
}) => {
  const handleDelete = async (e: any) => {
    e.preventDefault();

    handleDeleteCellar({
      id: cellar!.id,
      slug: cellar!.slug,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete cellar"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete cellar {cellar.name}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={(e) => handleDelete(e)} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmDeleteCellarDialog;
